var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercentage = function SvgPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18L18.5 2M8.5 4.5C8.5 6.433 6.933 8 5 8C3.067 8 1.5 6.433 1.5 4.5C1.5 2.567 3.067 1 5 1C6.933 1 8.5 2.567 8.5 4.5ZM19.5 15.5C19.5 17.433 17.933 19 16 19C14.067 19 12.5 17.433 12.5 15.5C12.5 13.567 14.067 12 16 12C17.933 12 19.5 13.567 19.5 15.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgPercentage;